import '../../assets/index53.css';var go = Object.defineProperty, bo = Object.defineProperties;
var Io = Object.getOwnPropertyDescriptors;
var L = Object.getOwnPropertySymbols;
var ao = Object.prototype.hasOwnProperty, io = Object.prototype.propertyIsEnumerable;
var eo = (o, e, r) => e in o ? go(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, t = (o, e) => {
  for (var r in e || (e = {}))
    ao.call(e, r) && eo(o, r, e[r]);
  if (L)
    for (var r of L(e))
      io.call(e, r) && eo(o, r, e[r]);
  return o;
}, _ = (o, e) => bo(o, Io(e));
var A = (o, e) => {
  var r = {};
  for (var a in o)
    ao.call(o, a) && e.indexOf(a) < 0 && (r[a] = o[a]);
  if (o != null && L)
    for (var a of L(o))
      e.indexOf(a) < 0 && io.call(o, a) && (r[a] = o[a]);
  return r;
};
import { jsx as c, jsxs as so } from "react/jsx-runtime";
import { createContext as wo, forwardRef as no, useContext as ko } from "react";
import { ErrorMessage as xo } from "../../molecules/ErrorMessage/index.js";
import { useForwardedRef as Go } from "../../hooks/useForwardedRef.js";
import { Label as Po } from "../Label/index.js";
import { Stack as No } from "../Stack/index.js";
import { e as K, c as E } from "../../get-size-Bc1Pz5yf.js";
import { c as M } from "../../create-vars-resolver-Bzbn9G-G.js";
import { f as D, u as F, B as O, p as to, h as V, e as So } from "../../factory-ueRxoNOV.js";
import { g as co } from "../../get-contrast-color-SC35uhiM.js";
import { g as lo } from "../../get-auto-contrast-value-BGSSZ1GD.js";
import { u as W } from "../../use-styles-DToiHEa6.js";
import { I as Ao, a as zo } from "../../InputsGroupFieldset-Bo-BOy1U.js";
import { u as Bo } from "../../DirectionProvider-CT8S13Cp.js";
import { U as $o } from "../../UnstyledButton-D9OCzDhz.js";
import { c as uo } from "../../create-optional-context-CQ2ahjKQ.js";
import { I as mo } from "../../Input--FNE961U.js";
import { u as po } from "../../use-id-D2tGiO9x.js";
import { u as Lo } from "../../use-uncontrolled-BT_j5D2R.js";
import { r as j } from "../../rem-CMQJ_ZTp.js";
import { F as Eo } from "../../Flex-BcSdq2bJ.js";
const [Vo, fo] = uo(), [Do, Fo] = uo();
var _o = { card: "m_9dc8ae12" };
const To = {
  withBorder: !0
}, Uo = M((o, { radius: e }) => ({
  card: {
    "--card-radius": K(e)
  }
})), q = D((o, e) => {
  const r = F("RadioCard", To, o), C = r, {
    classNames: a,
    className: n,
    style: d,
    styles: s,
    unstyled: i,
    vars: l,
    checked: g,
    mod: b,
    withBorder: G,
    value: y,
    onClick: I,
    name: h,
    onKeyDown: R
  } = C, u = A(C, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "checked",
    "mod",
    "withBorder",
    "value",
    "onClick",
    "name",
    "onKeyDown"
  ]), w = W({
    name: "RadioCard",
    classes: _o,
    props: r,
    className: n,
    style: d,
    classNames: a,
    styles: s,
    unstyled: i,
    vars: l,
    varsResolver: Uo,
    rootSelector: "card"
  }), { dir: k } = Bo(), p = fo(), P = typeof g == "boolean" ? g : (p == null ? void 0 : p.value) === y || !1, N = h || (p == null ? void 0 : p.name), $ = (v) => {
    if (R == null || R(v), ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"].includes(v.nativeEvent.code)) {
      v.preventDefault();
      const f = Array.from(
        document.querySelectorAll(
          `[role="radio"][name="${N || "__mantine"}"]`
        )
      ), x = f.findIndex((T) => T === v.target), m = x + 1 >= f.length ? 0 : x + 1, S = x - 1 < 0 ? f.length - 1 : x - 1;
      v.nativeEvent.code === "ArrowDown" && (f[m].focus(), f[m].click()), v.nativeEvent.code === "ArrowUp" && (f[S].focus(), f[S].click()), v.nativeEvent.code === "ArrowLeft" && (f[k === "ltr" ? S : m].focus(), f[k === "ltr" ? S : m].click()), v.nativeEvent.code === "ArrowRight" && (f[k === "ltr" ? m : S].focus(), f[k === "ltr" ? m : S].click());
    }
  };
  return /* @__PURE__ */ c(Do, { value: { checked: P }, children: /* @__PURE__ */ c(
    $o,
    _(t(t({
      ref: e,
      mod: [{ "with-border": G, checked: P }, b]
    }, w("card")), u), {
      role: "radio",
      "aria-checked": P,
      name: N,
      onClick: (v) => {
        I == null || I(v), p == null || p.onChange(y || "");
      },
      onKeyDown: $
    })
  ) });
});
q.displayName = "@mantine/core/RadioCard";
q.classes = _o;
const Oo = {}, H = D((o, e) => {
  const R = F("RadioGroup", Oo, o), { value: r, defaultValue: a, onChange: n, size: d, wrapperProps: s, children: i, name: l, readOnly: g } = R, b = A(R, ["value", "defaultValue", "onChange", "size", "wrapperProps", "children", "name", "readOnly"]), G = po(l), [y, I] = Lo({
    value: r,
    defaultValue: a,
    finalValue: "",
    onChange: n
  });
  return /* @__PURE__ */ c(Vo, { value: { value: y, onChange: (u) => !g && I(typeof u == "string" ? u : u.currentTarget.value), size: d, name: G }, children: /* @__PURE__ */ c(
    mo.Wrapper,
    _(t(t({
      size: d,
      ref: e
    }, s), b), {
      labelElement: "div",
      __staticSelector: "RadioGroup",
      children: /* @__PURE__ */ c(Ao, { role: "radiogroup", children: i })
    })
  ) });
});
H.classes = mo.Wrapper.classes;
H.displayName = "@mantine/core/RadioGroup";
function vo(a) {
  var n = a, { size: o, style: e } = n, r = A(n, ["size", "style"]);
  return /* @__PURE__ */ c(
    "svg",
    _(t({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 5 5",
      style: t({ width: j(o), height: j(o) }, e),
      "aria-hidden": !0
    }, r), {
      children: /* @__PURE__ */ c("circle", { cx: "2.5", cy: "2.5", r: "2.5", fill: "currentColor" })
    })
  );
}
var ho = { indicator: "m_717d7ff6", icon: "m_3e4da632", "indicator--outline": "m_2980836c" };
const jo = {
  icon: vo
}, Ko = M(
  (o, { radius: e, color: r, size: a, iconColor: n, variant: d, autoContrast: s }) => {
    const i = to({ color: r || o.primaryColor, theme: o }), l = i.isThemeColor && i.shade === void 0 ? `var(--mantine-color-${i.color}-outline)` : i.color;
    return {
      indicator: {
        "--radio-size": E(a, "radio-size"),
        "--radio-radius": e === void 0 ? void 0 : K(e),
        "--radio-color": d === "outline" ? l : V(r, o),
        "--radio-icon-size": E(a, "radio-icon-size"),
        "--radio-icon-color": n ? V(n, o) : lo(s, o) ? co({ color: r, theme: o, autoContrast: s }) : void 0
      }
    };
  }
), Y = D((o, e) => {
  const r = F("RadioIndicator", jo, o), C = r, {
    classNames: a,
    className: n,
    style: d,
    styles: s,
    unstyled: i,
    vars: l,
    icon: g,
    radius: b,
    color: G,
    iconColor: y,
    autoContrast: I,
    checked: h,
    mod: R,
    variant: u,
    disabled: w
  } = C, k = A(C, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "icon",
    "radius",
    "color",
    "iconColor",
    "autoContrast",
    "checked",
    "mod",
    "variant",
    "disabled"
  ]), p = g, P = W({
    name: "RadioIndicator",
    classes: ho,
    props: r,
    className: n,
    style: d,
    classNames: a,
    styles: s,
    unstyled: i,
    vars: l,
    varsResolver: Ko,
    rootSelector: "indicator"
  }), N = Fo(), $ = typeof h == "boolean" ? h : (N == null ? void 0 : N.checked) || !1;
  return /* @__PURE__ */ c(
    O,
    _(t(_(t({
      ref: e
    }, P("indicator", { variant: u })), {
      variant: u,
      mod: [{ checked: $, disabled: w }, R]
    }), k), {
      children: /* @__PURE__ */ c(p, t({}, P("icon")))
    })
  );
});
Y.displayName = "@mantine/core/RadioIndicator";
Y.classes = ho;
var Ro = { root: "m_f3f1af94", inner: "m_89c4f5e4", icon: "m_f3ed6b2b", radio: "m_8a3dbb89", "radio--outline": "m_1bfe9d39" };
const Mo = {
  labelPosition: "right"
}, Wo = M(
  (o, { size: e, radius: r, color: a, iconColor: n, variant: d, autoContrast: s }) => {
    const i = to({ color: a || o.primaryColor, theme: o }), l = i.isThemeColor && i.shade === void 0 ? `var(--mantine-color-${i.color}-outline)` : i.color;
    return {
      root: {
        "--radio-size": E(e, "radio-size"),
        "--radio-radius": r === void 0 ? void 0 : K(r),
        "--radio-color": d === "outline" ? l : V(a, o),
        "--radio-icon-color": n ? V(n, o) : lo(s, o) ? co({ color: a, theme: o, autoContrast: s }) : void 0,
        "--radio-icon-size": E(e, "radio-icon-size")
      }
    };
  }
), B = D((o, e) => {
  var X, oo;
  const r = F("Radio", Mo, o), Q = r, {
    classNames: a,
    className: n,
    style: d,
    styles: s,
    unstyled: i,
    vars: l,
    id: g,
    size: b,
    label: G,
    labelPosition: y,
    description: I,
    error: h,
    radius: R,
    color: u,
    variant: w,
    disabled: k,
    wrapperProps: p,
    icon: P = vo,
    rootRef: N,
    iconColor: $,
    onChange: C,
    mod: v
  } = Q, f = A(Q, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "id",
    "size",
    "label",
    "labelPosition",
    "description",
    "error",
    "radius",
    "color",
    "variant",
    "disabled",
    "wrapperProps",
    "icon",
    "rootRef",
    "iconColor",
    "onChange",
    "mod"
  ]), x = W({
    name: "Radio",
    classes: Ro,
    props: r,
    className: n,
    style: d,
    classNames: a,
    styles: s,
    unstyled: i,
    vars: l,
    varsResolver: Wo
  }), m = fo(), S = (X = m == null ? void 0 : m.size) != null ? X : b, T = r.size ? b : S, { styleProps: Co, rest: U } = So(f), Z = po(g), J = m ? {
    checked: m.value === U.value,
    name: (oo = U.name) != null ? oo : m.name,
    onChange: (ro) => {
      m.onChange(ro), C == null || C(ro);
    }
  } : {};
  return /* @__PURE__ */ c(
    zo,
    _(t(t(_(t({}, x("root")), {
      __staticSelector: "Radio",
      __stylesApiProps: r,
      id: Z,
      size: T,
      labelPosition: y,
      label: G,
      description: I,
      error: h,
      disabled: k,
      classNames: a,
      styles: s,
      unstyled: i,
      "data-checked": J.checked || void 0,
      variant: w,
      ref: N,
      mod: v
    }), Co), p), {
      children: /* @__PURE__ */ so(O, _(t({}, x("inner")), { mod: { "label-position": y }, children: [
        /* @__PURE__ */ c(
          O,
          _(t(t(_(t({}, x("radio", { focusable: !0, variant: w })), {
            onChange: C
          }), U), J), {
            component: "input",
            mod: { error: !!h },
            ref: e,
            id: Z,
            disabled: k,
            type: "radio"
          })
        ),
        /* @__PURE__ */ c(P, _(t({}, x("icon")), { "aria-hidden": !0 }))
      ] }))
    })
  );
});
B.classes = Ro;
B.displayName = "@mantine/core/Radio";
B.Group = H;
B.Card = q;
B.Indicator = Y;
const qo = "Radio-module__radioGroupLabel___A7yIY", Ho = "Radio-module__radio___dpBlV", Yo = "Radio-module__radioIcon___ynpHz", Zo = "Radio-module__radioInner___bZRFE", Jo = "Radio-module__radioBody___i-NSh", Qo = "Radio-module__radioLabel___VxVM0", Xo = "Radio-module__description___dO4dv", z = {
  radioGroupLabel: qo,
  radio: Ho,
  radioIcon: Yo,
  radioInner: Zo,
  radioBody: Jo,
  radioLabel: Qo,
  description: Xo
}, yo = wo({}), or = no((I, y) => {
  var h = I, {
    clearable: o = !1,
    description: e,
    error: r,
    horizontal: a,
    onChange: n,
    value: d,
    defaultValue: s,
    label: i,
    required: l,
    className: g,
    children: b
  } = h, G = A(h, [
    "clearable",
    "description",
    "error",
    "horizontal",
    "onChange",
    "value",
    "defaultValue",
    "label",
    "required",
    "className",
    "children"
  ]);
  const R = (u) => {
    if (!u.current)
      return;
    const w = u.current.checked;
    u.current.checked = !w, n(w ? null : u.current.value);
  };
  return /* @__PURE__ */ so(No, _(t({ gap: "sm", ref: y }, G), { children: [
    /* @__PURE__ */ c(
      B.Group,
      {
        "aria-invalid": !!r,
        classNames: {
          label: z.radioGroupLabel,
          root: z.radioGroupRoot
        },
        onChange: n,
        value: d,
        defaultValue: s,
        label: typeof i == "string" ? /* @__PURE__ */ c(Po, { label: i, withAsterisk: l }) : i,
        children: /* @__PURE__ */ c(yo.Provider, { value: o && { onClick: R } || {}, children: /* @__PURE__ */ c(Eo, { direction: a ? "row" : "column", gap: j(a ? 24 : 8), children: b }) })
      }
    ),
    e && !r && /* @__PURE__ */ c("p", { className: z.description, children: e }),
    r && /* @__PURE__ */ c(xo, { error: r })
  ] }));
}), rr = no((n, a) => {
  var d = n, { label: o, disabled: e } = d, r = A(d, ["label", "disabled"]);
  const { onClick: s } = ko(yo), i = Go(a);
  return /* @__PURE__ */ c(
    B,
    t({
      classNames: {
        body: z.radioBody,
        icon: z.radioIcon,
        inner: z.radioInner,
        label: z.radioLabel,
        radio: z.radio
      },
      disabled: e,
      label: o,
      onClick: s && (() => s(i)),
      onKeyDown: (l) => {
        i.current && l.key === " " && (l.preventDefault(), s && s(i));
      },
      ref: i,
      variant: "outline"
    }, r)
  );
}), wr = Object.assign({}, rr, {
  Group: or
});
export {
  wr as Radio
};
